export default "__VITE_ASSET__BEfSePWV__"